import { Component, ViewChild } from '@angular/core';
import { TableFilter } from '@app/interfaces';
import { BaseServerFilterEntity } from '@app/models';
import { FiltersComponent } from '../forms/components/filters/filters.component';

@Component({
	template: '',
})
export abstract class BaseFilterComponent<T> {
	@ViewChild(FiltersComponent) filter: FiltersComponent;

	filters: TableFilter<T> = { search: '' } as TableFilter<T>;
	serverFilters: BaseServerFilterEntity[] = [];

	needUpdateList(oldValues: BaseServerFilterEntity[], newValues: BaseServerFilterEntity[]): boolean {
		if (!oldValues && !newValues) {
			return false;
		}
		if ((oldValues && !newValues) || (!oldValues && newValues)) {
			return true;
		}

		if (oldValues.length !== newValues.length) {
			return true;
		}

		return oldValues.some((oldVal) => !newValues.some((v) => v.Key === oldVal.Key && v.Value === oldVal.Value));
	}

	applySearch(search: string): void {
		const tableFilter = { search } as Partial<TableFilter<T>>;
		this.applyFilter(tableFilter);
	}

	applyFilter(filterValue: Partial<TableFilter<T>>): void {
		const lookupValues: BaseServerFilterEntity[] = [];

		for (const key of Object.keys(filterValue)) {
			if (BaseServerFilterEntity.isBaseServerFilterEntity(filterValue[key])) {
				lookupValues.push(filterValue[key]);
			}
		}

		const needUpdateList = this.needUpdateList(this.serverFilters, lookupValues);
		this.serverFilters = lookupValues;
		if (needUpdateList) {
			this.refresh?.();
		}
		this.filters = { ...this.filters, ...filterValue };
	}

	removeFilter(key: string): void {
		let filterValue = null;
		if (key === 'search') {
			filterValue = '';
		}
		this.filters = { ...this.filters, [key]: filterValue };
	}

	clearFilters(): void {
		Object.keys(this.filters)
			.filter((key) => key !== 'search')
			.forEach((key) => this.removeFilter(key));
	}

	// server side logic
	protected abstract refresh?(): void;
}
